webpackJsonp([0],{

/***/ 1186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function warehouse(vm) {
	return vm.$resource('warehouse{/id}');
}

/* harmony default export */ __webpack_exports__["a"] = (warehouse);

/***/ }),

/***/ 1291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_mixins__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resource_warehouse__ = __webpack_require__(1186);



var created = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var _ref2, subsidiaries;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						this.resource = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__resource_warehouse__["a" /* default */])(this);
						_context.next = 3;
						return this.$http.get('//pms.controlinn.com/api' + '/hotel');

					case 3:
						_ref2 = _context.sent;
						subsidiaries = _ref2.data;

						this.subsidiaries = subsidiaries.data;
						if (this.minibarId) {
							this.loadData(this.minibarId);
						}

					case 7:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function created() {
		return _ref.apply(this, arguments);
	};
}();

var createMinibar = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var dataSend, baseUrl, url, method, message;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						dataSend = null;

						if (!this.model.externalCode) {
							_context2.next = 15;
							break;
						}

						if (!this.model.subsidiaryId) {
							this.model.subsidiaryId = this.model.subsidiaryId;
						}
						dataSend = {
							code: this.model.code,
							flagActive: this.model.flagActive,
							isMain: this.model.isMain,
							name: this.model.name,
							externalCode: this.model.externalCode,
							subsidiaryId: this.model.subsidiaryId
						};
						baseUrl = '//products.japisale.com' + '/p/warehouses';
						url = this.minibarId ? baseUrl + '/' + this.minibarId : baseUrl;
						method = this.minibarId ? 'patch' : 'post';
						message = this.minibarId ? 'editó' : 'creó';
						_context2.next = 10;
						return this.$http[method](url, dataSend);

					case 10:
						this.showNotification('El minibar se ' + message + ' correctamente.', 'success');
						this.$router.push(this.listHref);
						this.$router.push(this.listHref);
						_context2.next = 16;
						break;

					case 15:
						this.showNotification('La habitación es requerida, por favor elija una', 'warning');

					case 16:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function createMinibar() {
		return _ref3.apply(this, arguments);
	};
}();

var loadData = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(id) {
		var response;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						_context3.next = 2;
						return this.$http.get('//products.japisale.com' + '/p/warehouses/' + id);

					case 2:
						response = _context3.sent;

						this.model = response.data;
						this.loadRooms(this.model.subsidiaryId, this.model.externalCode);

					case 5:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function loadData(_x) {
		return _ref4.apply(this, arguments);
	};
}();

var loadRooms = function () {
	var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(subsidiaryId, externalCode) {
		var _ref6, rooms;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						this.model.externalCode = '';
						_context4.next = 3;
						return this.$http.get('//pms.controlinn.com/api' + '/roomtype/' + subsidiaryId + '/rooms');

					case 3:
						_ref6 = _context4.sent;
						rooms = _ref6.data;

						this.rooms = rooms.data;
						if (externalCode) {
							this.model.externalCode = externalCode;
						}

					case 7:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this);
	}));

	return function loadRooms(_x2, _x3) {
		return _ref5.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function mayusText() {
	return this.$route.name === 'warehouses-new' || this.$route.name === 'warehouses-config' ? 'Almacén' : 'Minibar';
}

function minusText() {
	return this.$route.name === 'warehouses-new' || this.$route.name === 'warehouses-config' ? 'almacén' : 'minibar';
}

/* harmony default export */ __webpack_exports__["default"] = ({
	components: {},
	computed: {
		mayusText: mayusText,
		minusText: minusText
	},
	created: created,
	data: function data() {
		return {
			filterBySubsidiaryId: null,
			listHref: { name: 'minibar-list' },
			model: {
				code: null,
				externalCode: '',
				flagActive: true,
				isMain: false,
				name: null,
				codeRoom: '',
				subsidiaryId: 0
			},
			resource: null,
			rooms: [],
			roomSelected: null
		};
	},

	methods: {
		createMinibar: createMinibar,
		loadData: loadData,
		loadRooms: loadRooms
	},
	mixins: __WEBPACK_IMPORTED_MODULE_2__shared_mixins__["a" /* default */],
	name: 'minibar-new',
	props: ['minibarId']
});

/***/ }),

/***/ 1373:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".create-product[data-v-12d59070]{width:610px}.create-product .actions[data-v-12d59070]{margin-top:26px;width:0}.create-product .btn-primary[data-v-12d59070]{color:#fff;background-color:#29abe2;-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.1);box-shadow:0 2px 5px 0 rgba(0,0,0,.1);font-family:San Francisco Display Bold;height:38px;width:164px}.create-product .title-form[data-v-12d59070]{color:#2f302f;font-family:San Francisco Display Medium;font-weight:500;line-height:.6;padding-top:10px;text-align:left}.create-product .input-form[data-v-12d59070]{background-color:#fff;-webkit-box-shadow:inset 0 2px 5px 0 rgba(0,0,0,.2);box-shadow:inset 0 2px 5px 0 rgba(0,0,0,.2);height:40px;padding-left:10px;width:100%}.radio-keeping[data-v-12d59070]{display:-webkit-box;display:-ms-flexbox;display:flex;font-size:14px}.small[data-v-12d59070]{font-size:12px}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/minibar/Create.vue"],"names":[],"mappings":"AACA,iCACE,WAAa,CACd,AACD,0CACI,gBAAiB,AACjB,OAAS,CACZ,AACD,8CACI,WAAa,AACb,yBAA0B,AAC1B,8CAAmD,AAC3C,sCAA2C,AACnD,uCAA0C,AAC1C,YAAa,AACb,WAAa,CAChB,AACD,6CACI,cAAe,AACf,yCAA4C,AAC5C,gBAAiB,AACjB,eAAiB,AACjB,iBAAkB,AAClB,eAAiB,CACpB,AACD,6CACI,sBAAwB,AACxB,oDAAyD,AACjD,4CAAiD,AACzD,YAAa,AACb,kBAAmB,AACnB,UAAY,CACf,AACD,gCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,cAAgB,CACjB,AACD,wBACE,cAAgB,CACjB","file":"Create.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.create-product[data-v-12d59070] {\n  width: 610px;\n}\n.create-product .actions[data-v-12d59070] {\n    margin-top: 26px;\n    width: 0;\n}\n.create-product .btn-primary[data-v-12d59070] {\n    color: white;\n    background-color: #29abe2;\n    -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);\n            box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);\n    font-family: \"San Francisco Display Bold\";\n    height: 38px;\n    width: 164px;\n}\n.create-product .title-form[data-v-12d59070] {\n    color: #2f302f;\n    font-family: \"San Francisco Display Medium\";\n    font-weight: 500;\n    line-height: 0.6;\n    padding-top: 10px;\n    text-align: left;\n}\n.create-product .input-form[data-v-12d59070] {\n    background-color: white;\n    -webkit-box-shadow: inset 0 2px 5px 0 rgba(0, 0, 0, 0.2);\n            box-shadow: inset 0 2px 5px 0 rgba(0, 0, 0, 0.2);\n    height: 40px;\n    padding-left: 10px;\n    width: 100%;\n}\n.radio-keeping[data-v-12d59070] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 14px;\n}\n.small[data-v-12d59070] {\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1458:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1373);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("7b44d0f8", content, true);

/***/ }),

/***/ 1585:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "create-product"
  }, [_c('v-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createMinibar($event)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "text-xs-left": ""
    }
  }, [_c('p', {
    staticClass: "title-form mb-0"
  }, [_vm._v("Elige la sucursal y habitación en la que crearás el " + _vm._s(_vm.minusText))]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("(Para poder seleccionar la habitación es necesario seleccionar una o todas las sucursales).")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "pt-2": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.subsidiaries,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "label": "Sucursal",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "change": _vm.loadRooms
    },
    model: {
      value: (_vm.model.subsidiaryId),
      callback: function($$v) {
        _vm.model.subsidiaryId = $$v
      },
      expression: "model.subsidiaryId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "pt-2": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select ml-2",
    attrs: {
      "items": _vm.rooms,
      "item-text": "codeRoom",
      "item-value": "codeRoom",
      "disabled": _vm.rooms.length === 0,
      "label": "Todas las habitaciones",
      "min-width": "198",
      "max-height": "250",
      "single-line": "",
      "required": "",
      "bottom": ""
    },
    model: {
      value: (_vm.model.externalCode),
      callback: function($$v) {
        _vm.model.externalCode = $$v
      },
      expression: "model.externalCode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": "",
      "pt-3": ""
    }
  }, [_c('p', {
    staticClass: "title-form mb-0"
  }, [_vm._v("Detalles del " + _vm._s(_vm.mayusText))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "pt-2": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "placeholder": ("Nombre del " + _vm.minusText),
      "required": ""
    },
    model: {
      value: (_vm.model.name),
      callback: function($$v) {
        _vm.model.name = $$v
      },
      expression: "model.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "pt-2": "",
      "text-xs-left": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "placeholder": "Código",
      "maxlength": "10",
      "required": ""
    },
    model: {
      value: (_vm.model.code),
      callback: function($$v) {
        _vm.model.code = $$v
      },
      expression: "model.code"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("Máximo 10 caracteres")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('v-btn', {
    staticClass: "btn-save",
    attrs: {
      "type": "submit",
      "disabled": !_vm.model.name || !_vm.model.code || !_vm.model.externalCode
    }
  }, [_vm._v("\n\t\t\t\tGuardar\n\t\t\t")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1458)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1291),
  /* template */
  __webpack_require__(1585),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-12d59070",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/0.c4c4e2ffb5c0569c94bc.js